import { FC, ReactNode } from "react";

const IconHolder: FC<{icon:ReactNode}> = ({icon}) => {
  return <div className="bg-background-active outline-5 w-min rounded-full text-white outline-background-primary-light flex items-center outline">{icon}</div>;
};

export default IconHolder;
